var map = {
	"./": 67672,
	"./App": 73465,
	"./App.css": 93508,
	"./App.test": 86583,
	"./App.test.tsx": 86583,
	"./App.tsx": 73465,
	"./components/Footer/Footer": 16119,
	"./components/Footer/Footer.tsx": 16119,
	"./components/HomePage/About": 17273,
	"./components/HomePage/About.tsx": 17273,
	"./components/HomePage/Contact": 36509,
	"./components/HomePage/Contact.tsx": 36509,
	"./components/HomePage/HomePage": 76150,
	"./components/HomePage/HomePage.tsx": 76150,
	"./components/HomePage/ProjectCard/ProjectCard": 71231,
	"./components/HomePage/ProjectCard/ProjectCard.css": 67189,
	"./components/HomePage/ProjectCard/ProjectCard.tsx": 71231,
	"./components/HomePage/Projects": 96282,
	"./components/HomePage/Projects.tsx": 96282,
	"./components/HomePage/Skills": 64511,
	"./components/HomePage/Skills.tsx": 64511,
	"./components/Navbar/Navbar": 51006,
	"./components/Navbar/Navbar.css": 21041,
	"./components/Navbar/Navbar.tsx": 51006,
	"./components/Pages/Error": 50677,
	"./components/Pages/Error.tsx": 50677,
	"./components/Pages/PersonalProjects": 82055,
	"./components/Pages/PersonalProjects.tsx": 82055,
	"./components/Pages/TeamProjects": 68492,
	"./components/Pages/TeamProjects.tsx": 68492,
	"./data/projects": 58841,
	"./data/projects.ts": 58841,
	"./data/skills": 86531,
	"./data/skills.ts": 86531,
	"./data/teamprojects": 65069,
	"./data/teamprojects.ts": 65069,
	"./images/VAngov.webp": 9390,
	"./images/VAngovDark1.webp": 42354,
	"./images/abstract-bg1.webp": 33734,
	"./images/bg-skills.webp": 20673,
	"./images/bootstrap1.webp": 15123,
	"./images/corner-left.webp": 53720,
	"./images/corner.webp": 23434,
	"./images/css31.webp": 37139,
	"./images/decor1.png": 20746,
	"./images/gitlab.webp": 89173,
	"./images/hero-image1.webp": 47310,
	"./images/html51.webp": 38886,
	"./images/icons8-github-100.svg": 84000,
	"./images/icons8-github-48.svg": 53713,
	"./images/jQuery1.webp": 59240,
	"./images/js1.webp": 90019,
	"./images/logo.6ce24c58023cc2f8fd88.svg": 1334,
	"./images/next-dark1.webp": 66584,
	"./images/nextjs-white1.webp": 11337,
	"./images/project1.webp": 1004,
	"./images/project10.webp": 84156,
	"./images/project11.webp": 67959,
	"./images/project2.webp": 55456,
	"./images/project4.webp": 63651,
	"./images/project5.webp": 24134,
	"./images/project6.webp": 48765,
	"./images/project7.webp": 93122,
	"./images/project8.webp": 97540,
	"./images/project9.webp": 3102,
	"./images/react1.webp": 13549,
	"./images/scss1.webp": 64426,
	"./images/teamproject1.webp": 39274,
	"./images/teamproject2.webp": 1000,
	"./images/teamproject3.webp": 6506,
	"./images/teamproject4.webp": 50497,
	"./images/teamproject5.webp": 49942,
	"./images/teamproject6.webp": 51213,
	"./images/teamproject7.webp": 36697,
	"./images/teamproject8.webp": 32908,
	"./index": 67672,
	"./index.css": 51174,
	"./index.tsx": 67672,
	"./logo.svg": 31100,
	"./react-app-env.d": 44398,
	"./react-app-env.d.ts": 44398,
	"./reportWebVitals": 58983,
	"./reportWebVitals.ts": 58983,
	"./setupTests": 22887,
	"./setupTests.ts": 22887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;